import { currentDeveloperCacheKey } from "../developer/constants";
import type { AllRouteEndpoints } from "../routeTypes";

/**
 * Dismissing a banner writes to the current developer's `dismissed_banners` hash, so the
 * current-developer query has to be refetched. Without this the dismissed banner comes back
 * the next time its component mounts — switching schedule type, stepping through the wizard —
 * because the cached developer still says it was never dismissed.
 */
export const bannersDismissCacheKeys: AllRouteEndpoints[] = [currentDeveloperCacheKey];
